<template>
  <div>
    <div class="text-xs-right">
      <v-btn @click="$emit('close')" icon><v-icon>close</v-icon></v-btn>
    </div>
    <div v-if="input" class="px-4">
      <div class="form-control" :class="{ 'has-error': errors.has('Name') }">
        <label class="noto_sans_thaiblack">{{ $t('Consent name') }}</label>
        <input
          :data-vv-as="$t('Name')"
          v-validate="'required'"
          name="Name"
          v-model="input.consent_name"
          class="form-control"
          type="text"
        />
        <span class="text-error" v-if="errors.has('Name')">{{ errors.first('Name') }}</span>
      </div>
      <div class="form-control noto_sans_thaiblack" :class="{ 'has-error': errors.has('Details') }">
        <label>{{ $t('Details (html)') }}</label>
        <vue-editor v-if="input" v-model="input.consent_details"></vue-editor>
        <!-- <textarea
          style="height: auto"
          rows="5"
          :data-vv-as="$t('Details')"
          v-validate="'required'"
          name="Details"
          v-model="input.consent_details"
          class="form-control"
          type="text"
        /> -->
        <span class="text-error" v-if="errors.has('Details')">{{ errors.first('Details') }}</span>
      </div>
      <div class="py-3 text-xs-center">
        <v-btn outline color="grey" @click="$emit('close')">cancel</v-btn>
        <v-btn :loading="loading" color="primary" depressed @click="saveData">Save</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import { VueEditor, Quill } from 'vue2-editor'

export default {
  components: {
    VueEditor
  },
  props: ['edittype', 'editdata'],
  data() {
    return {
      loading: false,
      input: {
        consent_name: '',
        consent_details: ''
      }
    }
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = this.editdata
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    saveData() {
      var url,
        data = ''
      if (this.edittype == 'edit') {
        url = 'generalipdpaUpdateConsent'
        data = {
          pageid: this.selectedBot.pageid,
          id: this.editdata.id,
          consent_name: this.input.consent_name,
          consent_details: this.input.consent_details
        }
      } else if (this.edittype == 'create') {
        url = 'generalipdpaCreateConsent'
        data = {
          pageid: this.selectedBot.pageid,
          consent_name: this.input.consent_name,
          consent_details: this.input.consent_details
        }
      }
      this.loading = true
      api[url](data, async (err, response) => {
        this.loading = false
        await this.$swal.fire({ text: 'สำเร็จ', type: 'success' })
        this.$emit('onsave')
      })
    }
  }
}
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// src/components/view/template/generali/ConsentEdit.vue